import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Header from "../../components/Header";

const HistoryTask = () => {
  const [tasks, setTasks] = useState([]);
  const [filteredTasks, setFilteredTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const token = localStorage.getItem("token");

        // If token exists, send it in the Authorization header
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/task`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Add token to the request headers
            },
          }
        );
        setTasks(response.data.data);
        setFilteredTasks(response.data.data); // Set initial filtered tasks
      } catch (error) {
        console.error("Error fetching history:", error);
        alert("Failed to fetch history data.");
        localStorage.removeItem("token");
      } finally {
        setLoading(false);
      }
    };

    fetchHistory();
  }, []);

  useEffect(() => {
    // Filter tasks based on search query
    const statusMapping = {
      0: "Dibuat",
      1: "Ditugaskan",
      2: "Dibatalkan",
      3: "Lewat Deadline",
    };

    const result = tasks.filter((task) => {
      const statusText = statusMapping[task.status] || ""; // Ubah angka ke teks

      return (
        (task.task_no || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
        (task.unit || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
        (task.dl || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
        statusText.toLowerCase().includes(searchQuery.toLowerCase()) // Cari berdasarkan status dalam teks
      );
    });

    setFilteredTasks(result);
  }, [searchQuery, tasks]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-gray-600 text-lg">Loading history data...</p>
      </div>
    );
  }

  return (
    <>
      <Header title={"Histori Tugas"} />
      <div className="p-6 pt-24">
        <h1 className="text-2xl font-bold mb-6">Histori Tugas</h1>

        {/* Search input */}
        <div className="mb-4">
          <input
            type="text"
            className="p-2 border border-gray-300 rounded-lg w-full md:w-1/3"
            placeholder="Search tasks..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        <div className="overflow-x-auto">
          <table className="min-w-full table-auto border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 px-2 py-2 text-left">
                  No
                </th>
                <th className="border border-gray-300 px-4 py-2 text-left">
                  IDPEL
                </th>
                <th className="border border-gray-300 px-4 py-2 text-left">
                  Unit
                </th>
                <th className="border border-gray-300 px-4 py-2 text-left">
                  Deadline
                </th>
                <th className="border border-gray-300 px-4 py-2 text-left">
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredTasks.map((task, id) => (
                <tr key={id} className="hover:bg-gray-50">
                  <td className="border border-gray-300 px-2 py-2">{id + 1}</td>
                  <td className="border border-gray-300 px-4 py-2">
                    <Link
                      to={`/task-detail/${task.id}`}
                      className="text-blue-500"
                    >
                      {task.task_no}
                    </Link>
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {task.unit}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {task.dl}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {task.status === 1
                      ? "Ditugaskan"
                      : task.status === 2
                        ? "Dibatalkan"
                        : task.status === 3
                          ? "Lewat Deadline"
                          : "Dibuat"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default HistoryTask;
